module.exports = __webpack_public_path__ + "static/media/404.92e2d7f3.svg";